import { render, staticRenderFns } from "./BookingsScheduleControls.vue?vue&type=template&id=3c512bf5&scoped=true&"
import script from "./BookingsScheduleControls.vue?vue&type=script&lang=js&"
export * from "./BookingsScheduleControls.vue?vue&type=script&lang=js&"
import style0 from "./BookingsScheduleControls.vue?vue&type=style&index=0&id=3c512bf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c512bf5",
  null
  
)

export default component.exports